/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, FormEvent, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Container,
  Grid,
  Paper,
  Box,
  MenuItem,
  TextField,
  Select,
  InputAdornment,
  IconButton,
  Button,
  SelectChangeEvent,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import Layout from "../Layout";
import { downloadRequest, fetchRequest } from "../../store/merchantStaging/actions";
import { ApplicationState } from "../../store";
import PageHeading from "../../common/pageHeading/PageHeading";
import ProgressIndicator from "../../common/progressIndicator/ProgressIndicator";
import useSession from "../../effects/useSession";
import pageStyles from "../pageStyles";
// import { Status, useAbortableEffect } from "../../effects/useAbortableEffect";
import MerchantStageTable, {
  ColumnToRecordMapping,
  MerchantStageTableParams,
} from "./merchantStagingTable/MerchantStagingTable";
import { MRT_PaginationState } from "material-react-table";
import CloudDownload from "@mui/icons-material/CloudDownload";
import { IS_DMG_INSTANCE } from "../../lib/utils";

interface Pagination {
  page: {
    limit: string;
    offset: string;
  };
  filter: { [index: string]: string };
  sort: string;
  cache?: string;
}

export default function MerchantStaging() {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = pageStyles();

  const urlSearchParams = new URLSearchParams(history.location?.search || "");
  const onboardingId = urlSearchParams.get('onboardingId') as string;
  let initParams = new MerchantStageTableParams();

  const [params, setParams] = useState<MerchantStageTableParams>(
    onboardingId ? {
      ...initParams,
      searchField: 'OnboardingID',
      searchText: onboardingId
    } :  initParams
  );
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  const [isDownloadAvailable, setIsDownloadAvailable] = useState(false);
  const session = useSession();

  const handleOnChange = (event: { target: { value: string } }) => {
    setParams({
      ...params,
      searchText: event.target.value,
      cache: 'ignore'
    });
  };

  const refreshData = (newParams: MerchantStageTableParams) => {
    const p: Pagination = {
      page: {
        limit: String(newParams.pageSize),
        offset: String(newParams.pageSize * newParams.page),
      },
      filter: {},
      sort: "",
      cache: newParams.cache
    };

    if (newParams.orderBy > -1)
      p.sort =
        (newParams.orderDirection == "desc" ? "-" : "") +
        ColumnToRecordMapping[newParams.orderBy];
    if (newParams.searchText) {
      console.log("search Text", newParams.searchText, newParams.searchField)
      p.filter[newParams.searchField] = (newParams.searchText || "").trim();
    }
    setParams({ ...newParams });

    dispatch(fetchRequest(null, p));
  };

  const { loading, data } = useSelector(
    (state: ApplicationState) => state.merchantStaging
  );

  const merchantsStore = data?.data ?? [];
  const merchantsStoreObjects = data?.meta?.totalObjects ?? 0;

  const onChangePage = (page: number, pageSize: number) => {
    const p = { ...params, pageSize: pageSize, page: page };
    refreshData(p);
  };

  const onSearchChange = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const p = { ...params, page: 0, cache: 'ignore' };
    refreshData(p);
  };

  useEffect(() => {
    onChangePage(pagination.pageIndex, pagination.pageSize);
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(()=>{
    if(params.searchField === 'OnboardingID' && params.searchText !== '' && merchantsStoreObjects > 0) {
      setIsDownloadAvailable(true);
    }else {
      setIsDownloadAvailable(false);
    }
  },[merchantsStoreObjects]);
  const handleDownload = () => {
    const p = {
      page: {
        limit: '99999',
        offset: '0',
      },
      filter: {},
      action:"export",
      cache:"ignore",
      header:["MID", "Name", "OnboardingID","OnboardedDate"],
      sort: "",
    };
    p.filter[params.searchField] = (params.searchText || "").trim();
    dispatch(downloadRequest( p));
  };
  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Paper>
                <PageHeading
                  entity="Staged Terminals"
                  heading="Staged Terminals"
                />
              </Paper>
              <Box my={2}>
                <Paper>
                  <Box
                    display={"flex"}
                    justifyContent={"space-between"}
                    pb={2}
                    pr={2}
                  >
                    <div></div>
                    <form
                      onSubmit={(e) => onSearchChange(e)}
                      style={{ padding: "1rem" }}
                    >
                      <Select
                        variant="standard"
                        value={params.searchField}
                        onChange={(event: SelectChangeEvent<string>) => {
                          setParams({
                            ...params,
                            searchField: event.target.value,
                          });
                        }}
                      >
                        <MenuItem value="TID" selected={true}>
                          TID
                        </MenuItem>
                        <MenuItem value="MID" >MID</MenuItem>
                      </Select>
                      <TextField
                        style={{ marginLeft: 5 }}
                        placeholder={"Search"}
                        variant="standard"
                        onChange={handleOnChange}
                        value={params.searchText}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton type="submit" edge="end">
                                <Search />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />

                    </form>
                  </Box>

                  {loading ? (
                    <ProgressIndicator />
                  ) : (
                    <MerchantStageTable
                      merchant={merchantsStore}
                      merchantCount={merchantsStoreObjects}
                      setPagination={setPagination}
                      pagination={pagination}
                    />
                  )}
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
